exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.list__item__subtitle {\n    height: auto;\n    white-space: normal;\n    font-size: 14px;\n}\n.list__tile {\n    height: auto;\n    padding: 5px 16px;\n}\n@media only screen and (max-width: 600px) {\n.list__tile__title {\n        font-size: 10px;\n}\n}\n\n", ""]);

// exports
